import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import './styles/app.css';

// Il carattere tipografico arriva da Google Fonts SENZA bloccare la prima schermata: prima
// era un foglio di stile "bloccante" e su rete mobile l'app restava bianca finché non arrivava.
// Nel frattempo si usa il carattere di sistema, poi si passa a quello di TBS.
{
  const l = document.createElement('link');
  l.rel = 'stylesheet';
  l.href = 'https://fonts.googleapis.com/css2?family=Schibsted+Grotesk:wght@400;500;600;700;800&display=swap';
  document.head.appendChild(l);
}

createRoot(document.getElementById('root')!).render(<StrictMode><App /></StrictMode>);

// PWA: service worker solo in produzione/staging (in sviluppo darebbe cache vecchie)
if ('serviceWorker' in navigator && location.hostname !== 'localhost' && location.hostname !== '127.0.0.1') {
  window.addEventListener('load', () => navigator.serviceWorker.register('/sw.js').catch(() => {}));
}
